module.exports = __webpack_public_path__ + "img/svgviewer-output.a95d4b9f.svg";